import React, { createContext } from 'react';
import { RouteParamValue } from 'shared/library/routes/define-route';

export type GenericRouteParams = Record<string, RouteParamValue>;

export const RouteContext = createContext<{ params: GenericRouteParams }>({ params: {} });

export function RouteProvider({
  children,
  params,
}: {
  children: React.ReactNode;
  params: GenericRouteParams;
}) {
  return <RouteContext.Provider value={{ params }}>{children}</RouteContext.Provider>;
}
